/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb3_SubtitleInputs */

const en_visa_eb3_subtitle = /** @type {(inputs: Visa_Eb3_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKILLED WORKERS & PROFESSIONALS`)
};

const pt_visa_eb3_subtitle = /** @type {(inputs: Visa_Eb3_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRABALHADORES QUALIFICADOS E PROFISSIONAIS`)
};

const es_visa_eb3_subtitle = /** @type {(inputs: Visa_Eb3_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRABAJADORES CALIFICADOS Y PROFESIONALES`)
};

/**
* | output |
* | --- |
* | "SKILLED WORKERS & PROFESSIONALS" |
*
* @param {Visa_Eb3_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb3_subtitle = /** @type {((inputs?: Visa_Eb3_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb3_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb3_subtitle(inputs)
	if (locale === "es") return es_visa_eb3_subtitle(inputs)
	return en_visa_eb3_subtitle(inputs)
});